<template>
    <div>
        <h5>All Existing Formulas</h5>
        <div class="card">
            <Button label="Create a formula" @click="createFormula" />
        </div>
        <!-- Formula Table -->
        <formula-table/>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import FormulaTable from '../../components/formula/FormulaTable.vue';

const router = useRouter();

const createFormula = () => {
    router.push({ name: 'AddFormula' });
};
</script>
